var exports = {
  "Lw": "UploadDropModal.module__overlay___UF9hNF",
  "r3": "UploadDropModal.module__dialog___UF9hNF",
  "ew": "UploadDropModal.module__dialogIconCircle___UF9hNF",
  "aY": "UploadDropModal.module__dialogIcon___UF9hNF",
  "tp": "UploadDropModal.module__dialogTextBlock___UF9hNF",
  "nl": "UploadDropModal.module__dialogTitle___UF9hNF",
  "HP": "UploadDropModal.module__dialogDescription___UF9hNF",
  "ly": "UploadDropModal.module__statusBanner___UF9hNF",
  "zm": "UploadDropModal.module__statusBannerActive___UF9hNF",
  "Sl": "UploadDropModal.module__statusBannerDefault___UF9hNF",
  "UX": "UploadDropModal.module__statusIndicator___UF9hNF",
  "Ie": "UploadDropModal.module__statusIndicatorActive___UF9hNF",
  "I8": "UploadDropModal.module__statusIcon___UF9hNF",
};

module.exports = exports;
